__turbopack_context__.v({
  "btn": "Button-module-scss-module__JsLnKG__btn",
  "danger": "Button-module-scss-module__JsLnKG__danger",
  "full": "Button-module-scss-module__JsLnKG__full",
  "ghost": "Button-module-scss-module__JsLnKG__ghost",
  "lg": "Button-module-scss-module__JsLnKG__lg",
  "loading": "Button-module-scss-module__JsLnKG__loading",
  "md": "Button-module-scss-module__JsLnKG__md",
  "outline": "Button-module-scss-module__JsLnKG__outline",
  "primary": "Button-module-scss-module__JsLnKG__primary",
  "secondary": "Button-module-scss-module__JsLnKG__secondary",
  "sm": "Button-module-scss-module__JsLnKG__sm",
  "spin": "Button-module-scss-module__JsLnKG__spin",
  "spinner": "Button-module-scss-module__JsLnKG__spinner",
});
